import { render, staticRenderFns } from "./Compliance.vue?vue&type=template&id=60f9fdd8&scoped=true"
import script from "./Compliance.vue?vue&type=script&lang=js"
export * from "./Compliance.vue?vue&type=script&lang=js"
import style0 from "./Compliance.vue?vue&type=style&index=0&id=60f9fdd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f9fdd8",
  null
  
)

export default component.exports